import type { ReactNode } from "react";
import { cx } from "class-variance-authority";

import * as styles from "./InputError.module.scss";

type InputErrorProps = {
  message: ReactNode;
  className?: string;
};

const InputError = ({ message, className }: InputErrorProps) => {
  return (
    <div className={cx(styles.container, className)}>
      <span className={styles.message}>{message}</span>
    </div>
  );
};

InputError.displayName = "InputError";

export { InputError };
